module.exports = __webpack_public_path__ + "img/p1.3140d8e2.png";